













































































import { computed, defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'
import { usePostcodeApi } from '@/composables/usePostcodeApi'
import { useGender } from '@/composables/useGender'
import { useComment } from '@/composables/useComment'
import { Contact } from '@/api/model/contact'

export default defineComponent({
    name: 'CreateLeadFormStep4',
    setup() {
        const { state, mentionableUsers } = useCreateLeadForm()
        const { genderOptions } = useGender()
        const { commentVisibilityOptions } = useComment()
        const contact = computed<Contact>(() => state.referral.contact as Contact)

        const postcodeApi = usePostcodeApi()
        const fetchingZipcodeData = computed(() => postcodeApi.loading.value)
        const validZipcodeData = computed(() => postcodeApi.hasResult.value)

        async function checkZipcode() {
            if (!contact.value.zipcode || contact.value.zipcode.length < 6) {
                return
            }

            if (!contact.value.streetnumber || contact.value.streetnumber.length === 0) {
                return
            }

            await postcodeApi.search(
                contact.value.zipcode,
                contact.value.streetnumber,
            )

            if (postcodeApi.hasResult) {
                contact.value.spouseZipcode = postcodeApi.firstResult.value.postcode
                contact.value.spouseStreetname = postcodeApi.firstResult.value.street
                contact.value.spouseCity = postcodeApi.firstResult.value.city?.label
                contact.value.spouseCountry = 'Nederland'
            }
        }

        return {
            state,
            contact,
            genderOptions,
            commentVisibilityOptions,
            mentionableUsers,

            fetchingZipcodeData,
            validZipcodeData,
            checkZipcode,
        }
    },
})
